<script>
	import UISection from "../ui/UISection.svelte";
	import UIBreadcrumb from "../ui/UIBreadcrumb.svelte";
	import UICover from "../ui/UICover.svelte";
	import UITitle from "../ui/UITitle.svelte";
	import UILine from "../ui/UILine.svelte";
	import UIHeading from "../ui/UIHeading.svelte";
	import UIText from "../ui/UIText.svelte";
	import UIImage from "../ui/UIImage.svelte";
	import UIVideo from "../ui/UIVideo.svelte";

	import UIImageAndText from "../ui/UIImageAndText.svelte";
	import UIAboutRoundFrame from "../ui/UIAboutRoundFrame.svelte";
	import UICoverTitle from "../ui/UICoverTitle.svelte";

	import router from "../stores/router";
	import base from "../stores/base";

	const API = process.env.APP_API;

	let title = "";

	$: {
		let item = $base.menu.filter((item) => item.url === $router.path)[0];
		title = item ? item.label[$base.lang] : "";
		router.track(title.replace(/(<([^>]+)>)/gi, ""));
	}

	let item;
	fetch(API + "/about/detail")
		.then((res) => {
			return res.json();
		})
		.then((json) => {
			if (json.message) {
				console.log("----", json.message);
			} else {
				item = json;
			}
		})
		.catch((e) => {
			console.log("----error", e);
		});
</script>

<main>
	{#if item}
		<UICover image={item.cover} position={item.coverPosition}>
			<UITitle about>
				{@html item["title_" + $base.lang].split("\n").join("<br>")}
			</UITitle>
			<div class="PageAbout-CoverText">
				{@html item["description_" + $base.lang]
					.split("\n")
					.join("<br>")}
			</div>
		</UICover>

		{#each item.body as [type, data]}
			{#if type === "heading"}
				<UISection>
					<UIHeading
						data={{ ...data, text: data["text_" + $base.lang] }}
					/>
				</UISection>
			{:else if type === "text"}
				<UISection>
					<UIText
						data={{ ...data, text: data["text_" + $base.lang] }}
					/>
				</UISection>
			{:else if type === "image"}
				<UISection>
					<UIImage
						data={{
							...data,
							caption1: data["caption1_" + $base.lang],
							caption2: data["caption2_" + $base.lang],
							caption3: data["caption3_" + $base.lang],
						}}
					/>
				</UISection>
			{:else if type === "video"}
				<UISection>
					<UIVideo
						data={{
							...data,
							caption: data["caption_" + $base.lang],
						}}
					/>
				</UISection>
			{:else if type === "line"}
				<UISection>
					<UILine {data} />
				</UISection>
			{:else if type === "imageAndText"}
				<UIImageAndText {data} />
			{:else if type === "coverTitle"}
				<UICoverTitle
					data={{ ...data, text: data["text_" + $base.lang] }}
				/>
			{:else if type === "frameText"}
				<UISection paddingtop="1em" paddingbottom="1em">
					<UIAboutRoundFrame
						data={{
							...data,
							text: data["text_" + $base.lang],
							linkLabel: data["linkLabel_" + $base.lang],
						}}
					/>
				</UISection>
			{/if}
		{/each}

		<UIBreadcrumb bottom />
	{/if}
</main>

<style global>
	.PageAbout-CoverText {
		max-width: 800px;
		margin: 0 auto;
		font-size: 1.125em;
		color: #fff;
		text-shadow: 0 0 16px rgb(0 0 0 / 50%);
		letter-spacing: 0.2em;
	}
	.PageAbout-Cover {
		background-color: #bbb;
		background-repeat: no-repeat;
		background-position: center;
		background-size: cover;
		height: 240px;
		position: relative;
	}
	.pc .PageAbout-Cover {
		height: 320px;
	}
</style>
